import { useInfiniteQuery } from '@tanstack/react-query';

import { PostKey } from './keys';
import { PostService } from './postService';

export function useGetAssignedPostsInfinite() {
  return useInfiniteQuery({
    queryKey: [PostKey.POSTS_INFINITE],
    queryFn: ({ pageParam }) => PostService.getAssignedPosts(pageParam).then((response) => response.data),
    initialPageParam: { page: 0, pageSize: 20, sortOrder: 'DESC' as const },
    getNextPageParam: (lastPage, _allPages, lastPageParam) => {
      if (lastPage.length < lastPageParam.pageSize) {
        return undefined;
      }
      return { ...lastPageParam, page: lastPageParam.page + 1 };
    },
  });
}
